
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/petsitter/[locationSlug]/[sitterProfileSlug]",
      function () {
        return require("private-next-pages/petsitter/[locationSlug]/[sitterProfileSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/petsitter/[locationSlug]/[sitterProfileSlug]"])
      });
    }
  